"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.eCommodityState = exports.eConstructionType = exports.eBasisOfValuation = exports.eOccupancy = void 0;
const location_class_1 = __importDefault(require("./location.class"));
var eOccupancy;
(function (eOccupancy) {
    eOccupancy["DISTRIBUTION_CENTERS"] = "Distribution Centers";
    eOccupancy["COLD_STORAGE_WAREHOUSE"] = "Cold Storage Warehouse";
    eOccupancy["PUBLIC_WAREHOUSE"] = "Public Warehouse";
    eOccupancy["PRIVATE_WAREHOUSE"] = "Private Warehouse";
    eOccupancy["OPEN_LOT"] = "Open Lot";
    eOccupancy["TANK_FARM"] = "Tank Farm";
    eOccupancy["SILO_STORAGE"] = "Silo Storage";
    eOccupancy["MIX_USE_FACILITY"] = "Mix Use Facility";
})(eOccupancy = exports.eOccupancy || (exports.eOccupancy = {}));
var eBasisOfValuation;
(function (eBasisOfValuation) {
    eBasisOfValuation["REPLACEMENT_COST"] = "Replacement Cost";
    eBasisOfValuation["SELLING_PRICE"] = "Selling Price";
    eBasisOfValuation["INVOICE_VALUE"] = "Invoice Value";
})(eBasisOfValuation = exports.eBasisOfValuation || (exports.eBasisOfValuation = {}));
var eConstructionType;
(function (eConstructionType) {
    eConstructionType["FRAME"] = "Frame (Construction Code 1)";
    eConstructionType["JOISTED_MASONRY"] = "Joisted Masonry (Construction Code 2)";
    eConstructionType["NONCOMBUSTIBLE"] = "Noncombustible (Construction Code 3)";
    eConstructionType["MASONRY_NONCOMBUSTIBLE"] = "Masonry Noncombustible (Construction Code 4)";
    eConstructionType["MODIFIED_FIRE_RESISTIVE"] = "Modified Fire Resistive (Construction Code 5)";
    eConstructionType["FIRE_RESISTIVE"] = "Fire Resistive (Construction Code 6)";
})(eConstructionType = exports.eConstructionType || (exports.eConstructionType = {}));
var eCommodityState;
(function (eCommodityState) {
    eCommodityState["RAW_MATERIALS"] = "Raw Materials";
    eCommodityState["WORKS_IN_PROGRESS"] = "Works in progress";
    eCommodityState["UNPACKED_FINISHED_PRODUCT"] = "Unpackaged Finished Product";
    eCommodityState["PACKAGED_FINISHED_PRODUCT"] = "Packaged Finished Product";
})(eCommodityState = exports.eCommodityState || (exports.eCommodityState = {}));
exports.default = location_class_1.default;
//# sourceMappingURL=index.js.map